import React from 'react'

// components
import {
  CRow,
} from '@coreui/react-pro'
import FormTextInput from '../general-input-form/FormTextInput'
import FormTextAreaInput from '../general-input-form/FormTextAreaInput'
import FormSwitchInput from '../general-input-form/FormSwitchInput'

const AppForm = ({
  values,
  handleChange,
  errors,
}) => {
  return (
    <>
      <CRow className="mb-4">
        <FormTextInput 
          id='account_name'
          name='account_name'
          colSize='6'
          inputLabel='Account Name'
          className='mb-3'
          placeholder='Enter account name...'
          value={values.account_name}
          handleTextInput={handleChange}
          feedbackInvalid={errors.account_name}
          invalid={errors.account_name}
        />
        <FormTextInput 
          id='account_number'
          name='account_number'
          colSize='6'
          inputLabel='Account Number'
          className='mb-3'
          placeholder='Enter account number...'
          value={values.account_number}
          handleTextInput={handleChange}
          feedbackInvalid={errors.account_number}
          invalid={errors.account_number}
        />
        <FormTextInput 
          id='account_swift_code'
          name='account_swift_code'
          colSize='6'
          inputLabel='Account Swift Code'
          className='mb-3'
          placeholder='Enter account swift code...'
          value={values.account_swift_code}
          handleTextInput={handleChange}
          feedbackInvalid={errors.account_swift_code}
          invalid={errors.account_swift_code}
        />
        <FormTextInput 
          id='bank_name'
          name='bank_name'
          colSize='6'
          inputLabel='Bank Name'
          className='mb-3'
          placeholder='Enter bank name...'
          value={values.bank_name}
          handleTextInput={handleChange}
          feedbackInvalid={errors.bank_name}
          invalid={errors.bank_name}
        />
        <FormTextAreaInput
          id='bank_address'
          name='bank_address'
          colSize='6'
          inputLabel='Bank Address'
          className='mb-3'
          placeholder='Enter bank address...'
          rows='5'
          value={values.bank_address}
          handleTextAreaInput={handleChange}
          feedbackInvalid={errors.bank_address}
          invalid={errors.bank_address}
        />
        <FormSwitchInput 
          id='is_default_bank'
          name='is_default_bank'
          colSize='6'
          inputLabel='Default Bank?'
          className='mb-3'
          handleSwitch={handleChange}
          value={values.is_default_bank}
          invalid={errors?.is_default_bank}
        />
      </CRow>
    </>
  )
}

export default AppForm